import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Category from '@mui/icons-material/Category';
import axios from 'axios';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getcustomer } from '../redux/customer';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const dispatch = useDispatch();
  const agent = useSelector((state) => state.agent);
  const [open, setOpen] = React.useState(false);
  const [gender, setGender] = React.useState("none");
  const [businessType, setBusinessType] = React.useState("none");
  const [payment, setPayment] = React.useState("none");
  const [loading, setLoading] = React.useState(false);
  const [personName, setPersonName] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnackbarOpen(false);
  };

  const names = ["Products", "Seeds", "Fertilizers", "Machinery", "Irrigation"];

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const validateForm = () => {
    if (!document.getElementById("businessname").value) return "Business Name is required";
    if (gender === "none") return "Gender is required";
    if (!document.getElementById("contact").value) return "Contact is required";
    if (businessType === "none") return "Business Type is required";
    if (payment === "none") return "Payment Terms is required";
    if (payment === "Credit" && (!document.getElementById("days").value || Number(document.getElementById("days").value) <= 0))
      return "Valid number of days is required for Credit";
    return null;
  };

  const resetForm = () => {
    const fields = ["businessname", "contact", "address", "principal", "days", "others"];
    fields.forEach((id) => {
      const element = document.getElementById(id);
      if (element) element.value = "";
    });
    setGender("none");
    setBusinessType("none");
    setPayment("none");
    setPersonName([]);
  };

  const addCustomer = async () => {
    const validationError = validateForm();
    if (validationError) {
      handleSnackbarOpen(validationError, "error");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("https://server.agrotraciserp.com/api/customer/addcustomer/", {
        businessname: document.getElementById("businessname").value,
        gender: gender,
        contact: document.getElementById("contact").value,
        address: document.getElementById("address").value,
        principal: document.getElementById("principal").value,
        days: payment === "Credit" ? document.getElementById("days").value : "",
        businesstype: businessType,
        payment: payment,
        interests: personName,
        others: document.getElementById("others").value,
      });

      if (response.status === 200) {
        dispatch(getcustomer({ data: response.data }));
        handleSnackbarOpen("Customer Added Successfully", "success");
        resetForm();
        handleClose();
      } else {
        handleSnackbarOpen("Failed to Add Customer", "error");
      }
    } catch (err) {
      handleSnackbarOpen("Error Adding Customer", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<Category />} onClick={handleOpen}>
        Add Customer
      </Button>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Add New Customer
          <IconButton onClick={handleClose} sx={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
            onSubmit={(e) => {
              e.preventDefault();
              addCustomer();
            }}
          >
            <TextField
              id="businessname"
              label="Business Name"
              type="text"
              autoComplete="current-text"
              required
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Gender</InputLabel>
              <Select
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                label="Gender"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Co-operate">Co-operate</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="contact"
              label="Contact"
              type="tel"
              autoComplete="current-text"
              required
            />
            <TextField
              id="address"
              label="Address"
              type="text"
              autoComplete="current-text"
            />
            <TextField
              id="principal"
              label="Principal Agent Name"
              type="text"
              autoComplete="current-text"
            />
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Business Type</InputLabel>
              <Select
                value={businessType}
                onChange={(e) => setBusinessType(e.target.value)}
                label="Business Type"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Retailer">Retailer</MenuItem>
                <MenuItem value="Wholesaler">Wholesaler</MenuItem>
                <MenuItem value="Farmer">Farmer</MenuItem>
                <MenuItem value="Food Processing">Food Processing</MenuItem>
                <MenuItem value="Agent">Agent</MenuItem>
                <MenuItem value="Exporter">Exporter</MenuItem>
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Payment Terms</InputLabel>
              <Select
                value={payment}
                onChange={(e) => setPayment(e.target.value)}
                label="Payment Terms"
                required
              >
                <MenuItem value="none">Choose</MenuItem>
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Credit">Credit</MenuItem>
              </Select>
            </FormControl>
            {payment === "Credit" && (
              <TextField
                id="days"
                label="Allowed Days"
                type="number"
                InputLabelProps={{ shrink: true }}
                autoComplete="current-text"
                required
              />
            )}
            <FormControl sx={{ m: 1, width: '25ch' }}>
              <InputLabel>Market and Product Interests</InputLabel>
              <Select
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Market and Product Interests" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              id="others"
              label="Other Information"
              multiline
              rows={4}
              sx={{ m: 1, width: '52ch' }}
              helperText="Optional additional information"
            />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Box sx={{ textAlign: 'center', width: '100%' }}>
            {loading ? (
              <Button variant="outlined" disabled>Loading...</Button>
            ) : (
              <Button
                type="submit"
                variant="outlined"
                startIcon={<Category />}
                size="large"
                sx={{ bgcolor: '#e0eff9', color: '#1976d2' }}
                onClick={addCustomer}
              >
                Add Customer
              </Button>
            )}
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}